module.exports = __webpack_public_path__ + "static/media/cellular-ios.0e19db4e.webp";